import defaultSettings from '@/settings'

const title = defaultSettings.title
import i18n from '@/lang'
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${i18n.t('menu.' + pageTitle)} - ${title}`
  }
  return `${title}`
}
